import { Dispatch } from '@reduxjs/toolkit'

import {
    getFeedback as getFeedbackApiCall,
    getFeedbackCategories as getFeedbackCategoriesApiCall,
    patchFeedback,
} from '@/helpers/api/feedbackApi'
import { getUserFullName } from '@/helpers/getUserFullName'
import { FeedbackCategoryResource } from '@/models'
import {
    AUTH_UNSET_TOKENS,
    FEEDBACK_CATEGORIES_FAILURE,
    FEEDBACK_CATEGORIES_SUCCESS,
    FEEDBACK_FAILURE,
    FEEDBACK_SUBMIT,
    FEEDBACK_SUBMIT_FAILURE,
    FEEDBACK_SUBMIT_SUCCESS,
    FEEDBACK_SUCCESS,
    SET_LOADING,
} from '@/redux/actionTypes'

export const getFeedback = (feedbackUuid: string) => async (dispatch: Dispatch): Promise<void> => {
    dispatch({ type: SET_LOADING, loading: true })

    try {
        const response = await getFeedbackApiCall(feedbackUuid)
        const { owner, checkOut } = response.data.tracks
        const name = getUserFullName(owner)

        dispatch({ type: FEEDBACK_SUCCESS, name, date: checkOut })
    } catch (error) {
        dispatch({ type: FEEDBACK_FAILURE, errors: error })
    }

    dispatch({ type: SET_LOADING, loading: false })
}

export const getFeedbackCategories = () => async (dispatch: Dispatch): Promise<void> => {
    dispatch({ type: SET_LOADING, loading: true })

    try {
        const response = await getFeedbackCategoriesApiCall()

        dispatch({ type: FEEDBACK_CATEGORIES_SUCCESS, data: response.data })
    } catch (error) {
        dispatch({ type: FEEDBACK_CATEGORIES_FAILURE, errors: error })
    }

    dispatch({ type: SET_LOADING, loading: false })
}

export const submitFeedback = (id: string, remark: string, category: FeedbackCategoryResource) => async (dispatch: Dispatch): Promise<void> => {
    dispatch({ type: SET_LOADING, loading: true })
    dispatch({ type: FEEDBACK_SUBMIT })

    try {
        await patchFeedback(id, remark, category)
        dispatch({ type: FEEDBACK_SUBMIT_SUCCESS })
        dispatch({ type: AUTH_UNSET_TOKENS })
    } catch (error) {
        dispatch({ type: FEEDBACK_FAILURE, errors: error })
        dispatch({ type: FEEDBACK_SUBMIT_FAILURE, errors: error })
    }

    dispatch({ type: SET_LOADING, loading: false })
}
